import Honeybadger from '@honeybadger-io/js';
import { type ErrorHandler } from '@angular/core';

export class HoneybadgerErrorHandler implements ErrorHandler {
  handleError(error: unknown): void {
    if (!error) {
      return;
    }
    if (typeof error !== 'object') {
      return;
    }
    if ('originalError' in error && error.originalError instanceof Error) {
      Honeybadger.notify(error.originalError);
      return;
    }
    if (!(error instanceof Error)) {
      return;
    }
    Honeybadger.notify(error);
  }
}
